import uuidv4 from "uuid/v4";
import Vue from "vue";
import { ERequestType, fetchGetHelper, fetchPostHelper, fetchPutHelper } from "../../tools/fetch";

/*************************************
 State
 **/
const state = {
	clientIDListing: [],
	clientListing: {},
	isLoaded: false,
	cidEditing: "",
	savedSearchClient: "",
	totalClients: 0,
	currentPage: 1,
	dataGridClientsIds: [],
	dataGridClients: [],
};

/*************************************
 Getters
 **/
const getters = {
	/**
	 * get client by his cid
	 * @param {*} cid
	 */
	getClientByid: (state, getters, rootState, rootGetters) => (cid) => {
		let c = state.clientIDListing.find(function (val) {
			return val === cid;
		});
		let tmpClient = state.clientListing[c];
		// if client undefined return undefined
		if (tmpClient === undefined || tmpClient.name === undefined) return undefined;
		// else get tmpclient
		tmpClient.name = tmpClient.name.toUpperCase();
		let val = tmpClient.prenom.toString();
		tmpClient.prenom = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
		return tmpClient;
	},

	/**
	 * get client data by Nom, Prénom, mail or phone
	 * @param {*} name
	 * @param {*} prenom
	 * @param {*} mail
	 * @param {*} tel
	 */
	getClientByNPC: (state, getters, rootState, rootGetters) => (name, prenom, mail, tel) => {
		// let keyFound = ''
		let foundedClients = {};

		// find all client with name and prenom
		Object.entries(state.clientListing).forEach(([cid, cData]) => {
			if (cData.nameLc === name.toLowerCase() && cData.prenomLc === prenom.toLowerCase()) foundedClients[cid] = cData;
		});

		// if more than one client
		if (Object.entries(foundedClients).length > 1) {
			let foundedClient = null;
			Object.entries(foundedClients).forEach(([cid, cData]) => {
				if ((mail !== "" && cData.email === mail) || (tel !== "" && cData.tel === tel)) foundedClient = cData;
			});
			// if no client
			if (foundedClient === null) return undefined;
			// client founded
			return foundedClient;
			// if no clients founded
		} else if (Object.entries(foundedClients).length === 0) {
			return undefined;
			// if one client founded
		} else {
			let foundedClient;
			if ((mail !== "" && Object.entries(foundedClients)[0][1].email === mail) || (tel !== "" && Object.entries(foundedClients)[0][1].tel === tel))
				foundedClient = Object.entries(foundedClients)[0][1];
			return foundedClient;
		}
	},

	/**
	 * get All stored Clients
	 * @param {*} state
	 */
	getAllClients: (state) => {
		let clientsTab = [];
		Object.entries(state.clientListing).forEach(([cid, cData]) => {
			clientsTab.push(cData);
		});
		return clientsTab;
	},

	/**
	 * Clients store loading state
	 * @param {*} state
	 */
	getClientsStoreIsLoaded: function (state) {
		return state.isLoaded;
	},

	/**
	 * get client in edition
	 * @param {*} state
	 */
	getCidEditing: function (state) {
		return state.cidEditing;
	},

	/**
	 * get Saved Search Client for client book
	 * @param {*} state
	 */
	getSavedSearchClient: function (state) {
		return state.savedSearchClient;
	},

	/**
	 * Get current page
	 * @param {*} state
	 */
	getCurrentPage: function (state) {
		return state.currentPage;
	},

	/**
	 * Get total clients
	 * @param {*} state
	 */
	getTotalClients: function (state) {
		return state.totalClients;
	},

	/**
	 * Get client for data grid
	 * @param {*} state
	 */
	getDataGridClients: function (state) {
		let clients = [];
		state.dataGridClientsIds.forEach((cid) => {
			clients.push(state.clientListing[cid]);
		});
		return clients;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	/**
	 * store cdis listing helper for get user by cid
	 * @param {*} state
	 * @param {*} dbData
	 */
	setCIdsList(state, dbData) {
		state.clientIDListing = dbData;
	},

	/**
	 * store all clients
	 * @param {*} state
	 * @param {*} dbData
	 */
	setCsList(state, dbData) {
		state.clientListing = dbData;
	},

	/**
	 * update store clients byCid
	 * @param {*} state
	 * @param {*} dbData
	 */
	setDatasClientById(state, dbData) {
		if (dbData.cid) {
			Vue.set(state.clientListing, dbData.cid.toString(), dbData);
			let find = state.clientIDListing.find((el) => el === dbData.cid);
			if (find === undefined) state.clientIDListing.push(dbData.cid);
		}
	},

	/**
	 * store current client edited
	 * @param {*} state
	 * @param {*} val
	 */
	setCidEditing(state, val) {
		state.cidEditing = val;
	},

	/**
	 * store research client for client book
	 * @param {*} state
	 * @param {*} val
	 */
	setSavedSearchClient(state, val) {
		state.savedSearchClient = val;
	},

	/**
	 * store loading state for client
	 * @param {*} state
	 * @param {*} val
	 */
	setLoadedState(state, val) {
		state.isLoaded = val;
	},

	/**
	 * store client current page
	 * @param {*} state
	 * @param {*} val
	 */

	setCurrentPage(state, val) {
		state.currentPage = val;
	},

	/**
	 * store total clients
	 * @param {*} state
	 * @param {*} val
	 */
	setTotalClients(state, val) {
		state.totalClients = val;
	},

	/**
	 * store data grid clients
	 * @param {*} state
	 */
	setDataGridClients(state, val) {
		state.dataGridClients = val;
	},

	/**
	 * store data grid clients ids
	 * @param {*} state
	 */
	setDataGridClientsIds(state, val) {
		state.dataGridClientsIds = val;
	},

	/**
	 * clean store
	 * @param {*} state
	 */
	resetStore(state) {
		state.clientIDListing = [];
		state.clientListing = {};
		state.isLoaded = false;
		state.unsubscribeClientsSnapShot = null;
		state.unsubscribeClientsPublicSnapShot = null;
	},
};

/*************************************
 Action
 **/
const actions = {
	/**
	 * Clean store
	 * @param {*} store params
	 */
	cleanStore: function ({ state, rootState, commit, dispatch }) {
		commit("resetStore");
	},

	/**
	 * Create new client (check existing client in back office)
	 * @param {*} param0
	 * @param {*} payload
	 */
	createNewClient: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			let id = uuidv4();
			if (payload.cid === "passage") id = "passage";
			let newClient = Object.assign({}, payload);
			newClient.cid = id;
			newClient.countForm = 1;
			if (payload.countResa !== undefined) {
				newClient.countResa = payload.countResa;
			} else {
				newClient.countResa = 0;
			}
			if (payload.countShow !== undefined) {
				newClient.countShow = payload.countShow;
			} else {
				newClient.countShow = 0;
			}
			if (payload.countNoShow !== undefined) {
				newClient.countNoShow = payload.countNoShow;
			} else {
				newClient.countNoShow = 0;
			}
			if (payload.countCancel !== undefined) {
				newClient.countCancel = payload.countCancel;
			} else {
				newClient.countCancel = 0;
			}
			newClient.rgpdmail = false;
			newClient.rgpdsms = false;
			newClient.nameLc = payload.name.toLowerCase();
			newClient.prenomLc = payload.prenom.toLowerCase();
			fetchPostHelper(ERequestType.CLIENTS.CREATE, newClient)
				.then((res) => {
					commit("setDatasClientById", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},

	/**
	 * Update client existing
	 * Warn: client need restoid in param
	 * @param {*} param0
	 * @param {*} payload
	 */
	updateClient: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			fetchPutHelper(ERequestType.CLIENTS.UPDATE, payload)
				.then((res) => {
					commit("setDatasClientById", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},
	/**
	 * Update client existing
	 * Warn: client need restoid in param
	 * @param {*} param0
	 * @param {*} payload
	 */
	updateClientByCid: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			fetchPutHelper(ERequestType.CLIENTS.UPDATEBYCID, payload)
				.then((res) => {
					commit("setDatasClientById", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},

	/**
	 * Update client count with different type -> TODO: create object type (enum)
	 * @param {*} param0
	 * @param {*} payload
	 */
	updateClientCount: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		let client = getters["getClientByid"](payload.cid);
		if (client !== undefined) {
			return new Promise((resolve, reject) => {
				let nb = client[payload.type];
				if (nb === undefined) nb = 0;
				if (payload.sub) nb -= 1;
				else nb += 1;
				if (nb < 0) nb = 0;
				Vue.set(client, payload.type, nb);
				dispatch("updateClient", client)
					.then((res) => {
						commit("setDatasClientById", res.data);
						resolve(client);
					})
					.catch(function (error) {
						// The document probably doesn't exist.
						reject(error);
					});
			});
		}
	},

	/**
	 * CheckClient existing in db get client infos
	 * @param {*} param0
	 * @param {*} payload -> restoid, email, name, prenom, tel
	 */
	checkClientExisting: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			fetchGetHelper(
				ERequestType.CLIENTS.CHECK,
				`restoid=${payload.restoid}&name=${payload.name}&prenom=${payload.prenom}&tel=${payload.tel}&email=${payload.email}`,
			)
				.then((res) => {
					if (!res.data || res.data === "" || res.data === undefined) reject(new Error("No client found"));
					else {
						resolve(res);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	/**
	 * CheckClient existing in db get client infos
	 * @param {*} param0
	 * @param {*} payload -> restoid, email, name, prenom, tel
	 */
	checkClientByCidExisting: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.CLIENTS.GET_BY_CID, `restoid=${payload.restoid}&cid=${payload.cid}`)
				.then((res) => {
					if (!res.data || res.data === "" || res.data === undefined) reject(new Error("No client found"));
					else {
						commit("setDatasClientById", res.data);
						resolve(res);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	/**
	 * Get client by cid and refresh local datas
	 * @param {*} param0
	 * @param {*} payload
	 */
	refreshClientDatasByCid: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.CLIENTS.GET_BY_CID, `restoid=${payload.restoid}&cid=${payload.cid}`, rootGetters["newUsers/getUser"].token)
				.then((res) => {
					commit("setDatasClientById", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	/**
	 * Get client by cid and refresh local datas
	 * @param {*} param0
	 * @param {*} arrayOfClient
	 */
	refreshClientsDatasByCids: function ({ state, rootState, commit, dispatch, getters, rootGetters }, arrayOfClient) {
		return new Promise((resolve, reject) => {
			if (arrayOfClient.length > 0) {
				arrayOfClient.forEach((client) => {
					commit("setDatasClientById", client);
				});
			}
			resolve();
		});
	},

	/**
	 * Booking client process -> checkclient exist -> update or create
	 * @param {*} param0
	 * @param {*} payload -> client dform datas
	 */
	bookingClientProcess: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			// check if client exist
			dispatch("checkClientExisting", {
				restoid: payload.restoid,
				name: payload.name,
				prenom: payload.prenom,
				tel: payload.tel,
				email: payload.email,
			})
				.then((res) => {
					// TODO: set comment can be improove for data consomation
					// check comment value
					let comment = res.data.comment;
					if (payload.comment && payload.comment !== "") comment = payload.comment;
					// client exist just update infos
					dispatch("updateClient", {
						restoid: payload.restoid,
						cid: res.data.cid,
						clientPreFix: payload.clientPreFix,
						name: payload.name,
						prenom: payload.prenom,
						telPreFix: payload.telPreFix,
						tel: payload.tel,
						email: payload.email,
						civ: payload.civ,
						societe: payload.societe,
						comment: comment,
					}).then((result) => {
						// client was updated get current client
						resolve(result.data);
					});
				})
				.catch((err) => {
					// check comment value
					let comment = "";
					if (payload.comment && payload.comment !== "") comment = payload.comment;
					// client didn't exist
					dispatch("createNewClient", {
						restoid: payload.restoid,
						cid: payload.cid,
						clientPreFix: payload.clientPreFix,
						name: payload.name,
						prenom: payload.prenom,
						telPreFix: payload.telPreFix,
						tel: payload.tel,
						email: payload.email,
						civ: payload.civ,
						societe: payload.societe,
						comment: comment,
					})
						.then((result) => {
							// new was created
							resolve(result.data);
						})
						.catch((error) => {
							reject(err, error);
						});
				});
		});
	},

	/**
	 * Load all clients from db
	 * @param {*} param0
	 */
	loadClients: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload = { disableStore: false }) {
		return new Promise((resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];
			const disableStore = payload.disableStore || false;

			if (!userDatas) return reject(new Error("loadClients - Error no user datas mDB"));
			fetchGetHelper(ERequestType.CLIENTS.ALL, `restoid=${uid}`, userDatas.token)
				.then((res) => {
					// if no clients
					if (res.data && res.data.length === 0) {
						commit("setLoadedState", true);
						reject(new Error("loadClients - No clients found"));
					}

					if (disableStore) {
						resolve(res.data);
						return;
					}
					// init store datas with all clients
					let cListing = {};
					let cidListing = [];
					res.data.forEach(function (doc) {
						let data = doc;
						// sorting tags in alphabetical order
						if (data.tags !== undefined && data.tags.length > 0) {
							let tags = data.tags.slice(0);
							tags.sort(function (a, b) {
								if (a < b) return -1;
								if (a > b) return 1;
								return 0;
							});
							data.tags = tags;
						}
						cListing[doc.cid] = data;
						cidListing.push(doc.cid);
					});
					commit("setCIdsList", cidListing);
					commit("setCsList", cListing);
					commit("setLoadedState", true);

					resolve();
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	/**
	 * Load clients of one page
	 * @param {*} param0
	 * @param {*} payload -> page number
	 */
	loadClientsPage: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			const userDatas = rootGetters["newUsers/getUser"];
			const uid = rootGetters["newUsers/getUidPublic"];
			const search = state.savedSearchClient;
			const sort = payload.sort;
			const order = payload.order;
			const tags = payload.tags || [];
			const page = payload.page || state.currentPage;
			if (!userDatas) return reject(new Error("loadClients - Error no user datas mDB"));

			const params = new URLSearchParams();
			params.append("restoid", uid);
			params.append("page", page);
			params.append("pagesize", 10);
			params.append("search", search);
			params.append("sort", sort);
			params.append("order", order);

			if (tags.length > 0) {
				params.append("tags", JSON.stringify(tags));
			}

			fetchGetHelper(ERequestType.CLIENTS.BY_PAGE, params.toString(), userDatas.token)
				.then((res) => {
					if (res.data && res.data.length === 0) {
						commit("setLoadedState", true);
						reject(new Error("loadClients - No clients found"));
					}
					const { docs, totalDocuments, currentPage } = res.data;
					dispatch("refreshClientsDatasByCids", docs);

					commit("setCurrentPage", currentPage);
					commit("setTotalClients", totalDocuments);
					commit(
						"setDataGridClientsIds",
						docs.map((client) => client.cid),
					);

					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};

/*************************************
 Helpers
 **/

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
